function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  gap: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  @media (max-width: 575px) {\n    flex-direction: column-reverse;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import styled from "styled-components";
import { Col, Row, Grid } from "react-flexbox-grid";
export var SpacedCol = styled(Col)(_templateObject());
export var WrCol = styled(Col)(_templateObject1(), function(props) {
    return !!props.$noGrow && "flex-grow: 0;";
}, function(props) {
    return !!props.$spaceTop && "margin-top: 1rem;";
}, function(props) {
    return !!props.$noPadding && "padding: 0;";
});
export var WrRow = styled(Row)(_templateObject2(), function(props) {
    return props.$gap || 0;
}, function(props) {
    return !!props.$noGaps && "\n    margin: 0;\n    > ".concat(WrCol, " {\n      padding: 0;\n    }\n  ");
});
export var FullHeightRow = styled(Row)(_templateObject3());
export var FullHeightGrid = styled(Grid)(_templateObject4());
export var ReversibleRow = styled(Row)(_templateObject5());
export { Col, Row, Grid } from "react-flexbox-grid";
